interface Props {
  timeLeft: number;  // seconds remaining
  total: number;     // total seconds
}

export function TimerBar({ timeLeft, total }: Props) {
  const pct = total === 0 ? 0 : Math.max((timeLeft / total) * 100, 0);

  const fillClass =
    pct <= 15
      ? "timer-bar__fill timer-bar__fill--danger"
      : pct <= 35
      ? "timer-bar__fill timer-bar__fill--warning"
      : "timer-bar__fill";

  return (
    <div className="timer-bar" aria-label={`${timeLeft} sekunder igjen`}>
      <div className="timer-bar__track">
        <div className={fillClass} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
